import { WEBSITE_FLOW } from '../constants';

export const isRedeem = (flowId: string): boolean =>
    [WEBSITE_FLOW.ULC_REDEEM, WEBSITE_FLOW.CF_REDEEM, WEBSITE_FLOW.PYC_REDEEM].includes(flowId as WEBSITE_FLOW);

export const isFreeContent = (flowId: string): boolean => [
    WEBSITE_FLOW.DEMO,
    WEBSITE_FLOW.FREE_WEEKEND,
    WEBSITE_FLOW.GIVEAWAY,
    WEBSITE_FLOW.OPEN_BETA,
    WEBSITE_FLOW.TRIALS
].includes(flowId as WEBSITE_FLOW);

export const isTwitchPrime = (flowId: string): flowId is WEBSITE_FLOW.TWITCH_PRIME =>
    flowId === WEBSITE_FLOW.TWITCH_PRIME;

export const isBetaRegistration = (flowId: string): flowId is WEBSITE_FLOW.BETA_REGISTRATION =>
    flowId === WEBSITE_FLOW.BETA_REGISTRATION;

export const isBetaApproval = (flowId: string): flowId is WEBSITE_FLOW.BETA_APPROVAL =>
    flowId === WEBSITE_FLOW.BETA_APPROVAL;

export const isPromo = (flowId: string): flowId is WEBSITE_FLOW.PROMOTAB =>
    flowId === WEBSITE_FLOW.PROMOTAB;

export const isPYCRedeem = (flowId: string): flowId is WEBSITE_FLOW.PYC_REDEEM =>
    flowId === WEBSITE_FLOW.PYC_REDEEM;

export const isCodeFirstRedeem = (flowId: string): flowId is WEBSITE_FLOW.CF_REDEEM =>
    flowId === WEBSITE_FLOW.CF_REDEEM;

export const isFriendsReferral = (flowId: string): flowId is WEBSITE_FLOW.FRIENDS_REFERRAL =>
    flowId === WEBSITE_FLOW.FRIENDS_REFERRAL;
